import clsx from 'clsx'
import CloseIcon from '@ancon/wildcat-ui/shared/icons/close.svg'
import BackIcon from '@ancon/wildcat-ui/shared/icons/arrow-back-long.svg'

import HeadingText from '../../../app/components/HeadingText'
import BodyText from '../../../app/components/BodyText'
import { ModalHeaderProps } from '../../../app/components/modal/ModalHeader'

import styles from './OrderConfigurationModalHeader.module.scss'

type OrderConfigurationModalHeaderProps = ModalHeaderProps & {
  onBack: () => void
  className?: string
  isSecondStep?: boolean
}

export default function OrderConfigurationModalHeader({
  title,
  titleId,
  eyebrow,
  subtitle,
  onClose,
  onBack,
  className,
  isSecondStep = false,
}: OrderConfigurationModalHeaderProps) {
  function handleOnClickIconButton() {
    if (isSecondStep) {
      onBack()
    } else {
      onClose?.()
    }
  }

  const heading = (
    <HeadingText as="h2" id={titleId}>
      {title}
    </HeadingText>
  )

  return (
    <div
      className={clsx(
        styles.header,
        {
          [styles.headerWithClose]: !isSecondStep,
          [styles.headerWithBack]: isSecondStep,
        },
        className,
      )}
    >
      {eyebrow || subtitle ? (
        <div className={styles.titleGroup}>
          {eyebrow && <div className={styles.eyebrow}>{eyebrow}</div>}
          {heading}
          {subtitle && (
            <BodyText as="p" color="body-1">
              {subtitle}
            </BodyText>
          )}
        </div>
      ) : (
        heading
      )}
      {(isSecondStep || onClose) && (
        <div
          className={styles.actionButton}
          onClick={handleOnClickIconButton}
          role="presentation"
          aria-label="close"
        >
          {isSecondStep && <BackIcon />}
          {!isSecondStep && onClose && <CloseIcon />}
        </div>
      )}
    </div>
  )
}
